<!-- Large banner with separate person -->

<template>
  <Fragment>
    <img class="blue_bg" alt :class="customBg" />
    <div class="info" :class="extraClass">
      <div v-if="infoLogo" class="info-logo">
        <img :src="infoLogo" alt />
      </div>

      <h3 :class="{ onlyH3: !subTitle }">
        <span v-if="isTranslation || eosBanner" v-html="$t(title)"></span>
        <span v-else>{{ title }}</span>
      </h3>
      <span v-if="specialTitle" class="special_title">
        <span v-if="isTranslation">{{ $t(specialTitle) }}</span>
        <span v-else>{{ specialTitle }}</span>
      </span>
      <h3 v-if="eosBanner">
        <span v-html="$t(subTitle)"></span>
      </h3>
      <h5 style="position: absolute; bottom: 10px; right: 10px; color: #342988" v-if="eosBanner">*T&Cs apply</h5>
      <h4 v-else>{{ isTranslation ? $t(subTitle) : subTitle }}</h4>
      <div class="banner_button_pc" v-if="buttonLinkUrl">
        <el-button class="white_button" @click.native.stop="onButtonClick">
          {{ isTranslation ? $t(buttonText) : buttonText }}
        </el-button>
        <span class="terms_conditions" v-if="tncLink"
          ><a :href="tncLink" target="_blank">Terms & conditions apply</a></span
        >
      </div>
      <div class="banner_button_mobile" v-if="buttonLinkUrl" @click="onButtonClick">
        <el-button class="white_button">
          {{ isTranslation ? $t(buttonText) : buttonText }}
        </el-button>
      </div>
      <div class="download" v-if="downloadPic">
        <a class="android" :href="andriodAppLink" target="_blank"
          ><img src="@/assets/images/banner/google_play.png" alt
        /></a>

        <a class="iphone" :href="iosAppLink" target="_blank"
          ><img src="@/assets/images/banner/apple_store.png" alt
        /></a>
      </div>
    </div>
    <div v-if="rightSideImg" class="r-side-img" :class="rightSideImgClass">
      <img :src="rightSideImg" alt />
    </div>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment';
import { GOLD_TRADING_IOS_APP_LINK, GOLD_TRADING_ANDROID_APP_LINK } from '@/constants/thirdPartyLink';

export default {
  name: 'BannerItem',
  props: [
    'customBg',
    'infoLogo',
    'extraClass',
    'title',
    'subTitle',
    'buttonLink',
    'languageButtonLink',
    'buttonText',
    'tncLink',
    'downloadPic',
    'rightSideImg',
    'iosAppLink',
    'andriodAppLink',
    'specialTitle',
    'isTranslation',
    'rightSideImgClass',
    'eosBanner'
  ],
  components: {
    Fragment
  },
  computed: {
    buttonLinkUrl() {
      let url = this.buttonLink ?? null;
      if (this.languageButtonLink) {
        url = this.languageButtonLink[this.$i18n.locale] ?? this.languageButtonLink['default'] ?? url;
      }

      return url;
    }
  },
  data() {
    return {
      GOLD_TRADING_IOS_APP_LINK,
      GOLD_TRADING_ANDROID_APP_LINK
    };
  },
  methods: {
    onButtonClick() {
      window.open(this.buttonLinkUrl);
    }
  }
};
</script>

<style lang="scss" scoped>
@import './bannerItem.scss';
</style>
<style>
.white_button:focus,
.white_button:hover,
.white_button:active {
  background-color: #fff;
  color: #0051ff;
  border: solid 1px #0051ff;
}
</style>
